/**
 * Created by swchen on 2017/6/27.
 */


import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("api/nursecarecore/userPermission");

function listAllPermsAsync(param) {
    return remoteCall.invoke("listAllPerms", param);
}

function myPermissionsAsync(param) {
    return remoteCall.invoke("myPermissions", param);
}


function findUserWithoutExceptionHandleAsync(param) {
    return remoteCall._invoke("findUser", param)
}

/**
 * 企业所有可用的权限 功能面板不一定启用
 * @returns {Promise<*>}
 */
function allAuthPermissionsWithoutExceptionHandleAsync() {
    // return remoteCall._invoke("allAuthPermissions"); 企业管理员启用的权限
    // return remoteCall._invoke("allAuthPermissions"); 企业所有可以用并且开启的权限
    return remoteCall._invoke("allAuthPermissions");
}

function myPermissionsWithoutExceptionHandleAsync() {
    return remoteCall._invoke("myPermissions");
}

function myMenusFlatWithoutExceptionHandleAsync() {
    return remoteCall._invoke("myMenusFlat");
}

function findAllPermissionGroupsAsync(param) {
    return remoteCall.invoke("findAllPermissionGroups", param);
}

/**
 * 第一次使用 配置首页权限
 * @param param
 * @returns {*}
 */
function updateIndexPermConfigAsync(param) {
    return remoteCall.invoke("updateIndexPermConfig", param);
}

/**
 * 查询所有可用的权限
 * @param param
 * @returns {*}
 */
function allAuthPermissionsAsync(param) {
    return remoteCall.invoke("allAuthPermissions", param);
}

/**
 * 功能控制面板 控制权限开关
 * @param param
 * @returns {*}
 */
function setPermissionStatusAsync(param) {
    return remoteCall.invoke("setPermissionStatus", param);
}

export default {
    listAllPermsAsync,
    myPermissionsAsync,
    findUserWithoutExceptionHandleAsync,
    myPermissionsWithoutExceptionHandleAsync,
    myMenusFlatWithoutExceptionHandleAsync,
    findAllPermissionGroupsAsync,
    allAuthPermissionsWithoutExceptionHandleAsync,
    updateIndexPermConfigAsync,
    allAuthPermissionsAsync,
    setPermissionStatusAsync,
};
